import React, { useEffect, useState } from 'react';
import Carga from '../../pages/CargaGraficoPagina/CargaPagina';
import axios from 'axios';
import {API_URL_LOCALE_BASE} from '../../configuration/config'
import Swal from 'sweetalert2'
import Loading from "../shared/Loading/Loading";
import { getAllFuenteGrafico, getFuenteGrafico } from '../../services/service';

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})

const MainCP = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectOptions, setSelectOptions] = useState<object[]>([]);

  useEffect(() => {
    setIsLoading(true);
    getAllFuenteGrafico().then((r: { data: any; }) =>{
      console.log('Fuente',r.data.data);
      setSelectOptions(r.data.data.map((item: { id: any; nombre: any; }) => ({ value: item.id, label: item.nombre })))
  }).catch((e: any) => {}).finally(() => setIsLoading(false))

    
  }, [])
  return (
    <>
      {isLoading ? <Loading loading={isLoading} /> : null}
      <Carga options={selectOptions}/>
    </>
  )
}

export default MainCP;



